import { useState } from "react";
import toast from "react-hot-toast";

// Default reset window matches the existing per-cell copy buttons across the offers/growth UI;
// callers can override if a different feel is needed.
const DEFAULT_RESET_MS = 1500;

export function useCopyToClipboard(resetMs: number = DEFAULT_RESET_MS) {
  const [copiedValue, setCopiedValue] = useState<string | null>(null);

  const copy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopiedValue(value);
      setTimeout(() => setCopiedValue(null), resetMs);
    } catch {
      toast.error("Failed to copy");
    }
  };

  return { copiedValue, copy };
}
